export default "__VITE_ASSET__DT0c4qu7__"